<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
        <a-collapse v-model:activeKey="activeKey" accordion>
            <a-collapse-panel v-for="item in collapseList.title" :key="item.id" :header="item.title">
                <p v-html="collapseList.text"></p>
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import pageTool from "@/components/nav/pageTool"
const banner = require('@/assets/img/page_banner_1.png')
import { onMounted, reactive, watch, ref } from 'vue'
import {useRoute} from 'vue-router'
import {getProcessDetail, getProcessList} from '@/api/policy'
export default {
    name: "NewSubjectDetail",
    setup() {
        const route = useRoute()
        const title = reactive({
            cn: '',
            en: '',
            hasSearch: false,
            titleStyle: false,
            banner
        })
        const collapseList = reactive({
            title: [],
            text: '',
            secId: ''
        })
        const activeKey = ref(['1'])
        const getText = async (id) => {
            const data = await getProcessDetail(collapseList.secId + '&' + id)
            // console.log(data)
            collapseList.text = data.text
        }
        watch(activeKey, val => {
            getText(val)
        })
        const initData = async (id, secId) => {
            collapseList.secId = secId
            const params = {"current": 1,"model": {"firstCategoryId": 200001, "secondCategoryId": secId}, "size": 100}
            const data = await getProcessList(params)
            collapseList.title = data.records
        }
        onMounted(() => {
            const params = JSON.parse(route.query.params)
            title.cn = params.title
            initData(params.id, params.secId)
        })
        return {
            title,
            activeKey,
            collapseList,
            getText
        }
    },
    components: {
        Header,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
    .content {
        width 100%
        overflow hidden
    }
    .content >>> .ant-collapse > .ant-collapse-item > .ant-collapse-header {
        color #44A73D
        font-size 14px
        font-weight bolder
    }
</style>